(function () {
  'use strict';

  let interactionLoaded = false;
  const passiveOpts = { once: true, passive: true };
  const scripts = window.__themeInteractionScripts || [];
  const polyfillSrc = window.__themePopoverPolyfillSrc;

  // Yield back to main thread between each script injection
  function yieldToMain() {
    return new Promise(resolve => setTimeout(resolve, 0));
  }

  async function injectScripts() {
    // Polyfill first (conditional, lightweight check)
    if (polyfillSrc && !('popover' in HTMLElement.prototype)) {
      const poly = document.createElement('script');
      poly.src = polyfillSrc;
      poly.type = 'module';
      document.head.appendChild(poly);
      await yieldToMain(); // yield after each injection
    }

    // Inject each script in its own task — breaks the 195ms into ~10ms chunks
    for (const src of scripts) {
      if (document.querySelector('script[src="' + src + '"]')) continue;
      const script = document.createElement('script');
      script.src = src;
      script.type = 'module';
      document.head.appendChild(script);
      await yieldToMain(); // ← KEY: yields between each injection
    }
  }

  function loadInteractionScripts() {
    if (interactionLoaded) return;
    interactionLoaded = true;
    removeListeners();

    if ('scheduler' in window && 'postTask' in window.scheduler) {
      // Use Chromium's task scheduler with background priority
      window.scheduler.postTask(injectScripts, { priority: 'background' });
    } else if ('requestIdleCallback' in window) {
      requestIdleCallback(() => injectScripts(), { timeout: 2000 });
    } else {
      setTimeout(() => injectScripts(), 50);
    }
  }

  function removeListeners() {
    ['mouseover', 'touchstart', 'scroll', 'keydown'].forEach(evt => {
      window.removeEventListener(evt, loadInteractionScripts);
    });
  }

  ['mouseover', 'touchstart', 'scroll', 'keydown'].forEach(evt => {
    window.addEventListener(evt, loadInteractionScripts, passiveOpts);
  });

  setTimeout(loadInteractionScripts, 8000);
})();